import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { Box, useTheme } from "@mui/material";
import { useCallback, useEffect, useState } from "react";

import { ipcRendererCallback, ipcRendererSend, removeIpcListener } from "@/utils";
export default function UpgradeApplicationWindow({ setNoClose }: { setNoClose: (value: boolean) => void }) {
  const theme = useTheme();
  const [disabled, setDisabled] = useState<boolean>(false);
  const [downloadProgress, setDownloadProgress] = useState<number>(0);
  const roundedDownloadProgress = downloadProgress.toFixed(0);
  const downloadProgressCallback = useCallback((_: any, value: number) => setDownloadProgress(value), []);

  const startUpgrade = () => {
    setDisabled(() => true);
    setNoClose(true);
    ipcRendererSend("download-update");
  };

  useEffect(() => {
    ipcRendererCallback("download-progress", downloadProgressCallback);
    return () => {
      removeIpcListener("download-progress", downloadProgressCallback);
    };
  }, [downloadProgressCallback]);

  return (
    <Box>
      {disabled ? (
        <Box>
          <Box sx={{ mb: 1 }}>Downloading Update</Box>

          <Box
            component="span"
            sx={{
              padding: "4px",
              lineHeight: "17px",
              overflowY: "hidden",
              display: "inline-block",
              background: theme.palette.info.dark,
            }}
          >
            {roundedDownloadProgress}%
          </Box>

          <Box sx={{ width: "100%" }}>
            <Box
              sx={{
                width: `${downloadProgress}%`,
                height: "5px",
                background: `linear-gradient(90deg, ${theme.palette.info.main}, ${theme.palette.info.dark})`,
              }}
            />
            <Box
              sx={{
                width: `${downloadProgress}%`,
                height: "2px",
                background: `linear-gradient(90deg, ${theme.palette.brand.primary.light}, ${theme.palette.info.dark})`,
              }}
            />
          </Box>
        </Box>
      ) : (
        <Box>
          <Box>Storyboard Chat is ready to update!</Box>
          <Box sx={{ fontSize: "0.9rem", color: "#ccc", mb: 2 }}>
            Click <strong>upgrade</strong> to install the latest version.
          </Box>
          <div>
            <button
              onClick={() => startUpgrade()}
              className="basic-button"
              style={{
                width: "100%",
                border: "solid 2px #777",
                borderRadius: "0.5rem",
                padding: "0.5rem",
                textAlign: "center",
                justifyContent: "center",
              }}
            >
              Upgrade Now <RestartAltIcon sx={{ color: "#ccc" }} />
            </button>
          </div>
        </Box>
      )}
    </Box>
  );
}
